import React from "react";

export default function CommonAreaForm({
    state,
    handleUpdate,
    showPreviewImageCommon,
    onSubmit,
    submitText,
    editar
}) {

    const seleccionados = Array.isArray(state.subfraccionamientosSeleccionados)
        ? state.subfraccionamientosSeleccionados.map((id) => id.toString())
        : state.subfraccionamientosSeleccionados
            ? [state.subfraccionamientosSeleccionados.toString()]
            : [];

    const subs = state.subfraccionamientos || [];

    return (
        <div className="tw-flex tw-flex-col tw-w-full tw-items-center">
            <form className="tw-w-full tw-space-y-1.5 tw-text-xs" id="commonAreaForm" onSubmit={onSubmit}>

                {/* Bloque datos básicos */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm">
                    <h3 className="tw-font-extrabold tw-mb-1 tw-text-lg tw-underline tw-text-purple-950">Datos básicos</h3>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-1.5">
                        {/* Nombre */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Nombre:</label>
                            <input
                                type="text"
                                className="input-edit-sm tw-text-left"
                                value={state.nombre}
                                onChange={(e) => handleUpdate({ nombre: e.target.value })}
                            />
                        </div>

                        {/* Subfraccionamiento */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">{state.subLabel}:</label>
                            <div className="tw-flex tw-flex-col tw-border tw-rounded tw-p-2 tw-max-h-40 tw-overflow-y-auto">
                                <label className="tw-flex tw-items-center tw-space-x-2">
                                    <input
                                        type="checkbox"
                                        checked={
                                            subs.length > 0 &&
                                            seleccionados.length === subs.length
                                        }
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            if (checked) {
                                                const allIds = subs.map((s) =>
                                                    s.id_subfraccionamiento.toString()
                                                );
                                                handleUpdate({ subfraccionamientosSeleccionados: allIds });
                                            } else {
                                                handleUpdate({ subfraccionamientosSeleccionados: [] });
                                            }
                                        }}
                                    />
                                    <span>TODOS</span>
                                </label>
                                {subs.map((sub) => (
                                    <label
                                        key={sub.id_subfraccionamiento}
                                        className="tw-flex tw-items-center tw-space-x-2"
                                    >
                                        <input
                                            type="checkbox"
                                            value={sub.id_subfraccionamiento}
                                            checked={seleccionados.includes(
                                                sub.id_subfraccionamiento.toString()
                                            )}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const already = seleccionados.includes(value);
                                                const newSelection = already
                                                    ? seleccionados.filter((id) => id !== value)
                                                    : [...seleccionados, value];
                                                handleUpdate({ subfraccionamientosSeleccionados: newSelection });
                                            }}
                                        />
                                        <span>{sub.nombre}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Categoría */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Categoría:</label>
                            <select
                                value={state.categoria}
                                onChange={(e) => handleUpdate({ categoria: e.target.value })}
                                className="input-edit-sm tw-text-left"
                            >
                                {state.categories.map((cat) => (
                                    <option key={cat.id_categoria} value={cat.id_categoria}>
                                        {cat.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Depósito */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Depósito:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.fianza}
                                onChange={(e) => handleUpdate({ fianza: e.target.value })}
                            />
                        </div>

                        {/* Imagen */}
                        {editar && (<div className="tw-flex tw-flex-col tw-items-center tw-col-span-2">
                            <div className="tw-relative tw-flex tw-justify-center">
                                <img
                                    src={state.imagenArea || require("../../img/empty_image.png")}
                                    alt="Preview área común"
                                    className="tw-w-48 tw-h-28 tw-object-cover tw-rounded tw-shadow tw-mx-auto"
                                />
                                <label className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-black tw-bg-opacity-50 tw-text-white tw-cursor-pointer tw-opacity-0 hover:tw-opacity-100 tw-transition tw-text-xs">
                                    <i className="fas fa-file-upload tw-mb-1"></i>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={showPreviewImageCommon}
                                        className="hidden"
                                    />
                                    <span>Subir imagen</span>
                                </label>
                            </div>
                        </div>)}
                    </div>
                </div>

                {/* Bloque reservas */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm">
                    <h3 className="tw-font-extrabold tw-mb-1 tw-text-lg tw-underline tw-text-purple-950">Configuración de reservas</h3>
                    <div className="tw-grid tw-grid-cols-2 tw-gap-1.5">
                        {/* Días previos */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Días previos:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.diasPrevios}
                                onChange={(e) => handleUpdate({ diasPrevios: e.target.value })}
                            />
                        </div>
                        {/* Minutos previos */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Minutos previos:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.minutosPrevios}
                                onChange={(e) => handleUpdate({ minutosPrevios: e.target.value })}
                            />
                        </div>
                        {/* Disponibilidad */}
                        <div className="tw-flex tw-flex-col tw-col-span-2">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Disponibilidad:</label>
                            <div className="tw-flex tw-space-x-4">
                                <label className="tw-flex tw-items-center tw-space-x-1.5">
                                    <input
                                        type="radio"
                                        checked={state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: true })}
                                    />
                                    <span>Días disponibles</span>
                                </label>
                                <label className="tw-flex tw-items-center tw-space-x-1.5">
                                    <input
                                        type="radio"
                                        checked={!state.isDiasDisponible}
                                        onChange={() => handleUpdate({ isDiasDisponible: false })}
                                    />
                                    <span>Horas disponibles</span>
                                </label>
                            </div>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left tw-mt-0.5"
                                value={state.tiempoDisponible}
                                onChange={(e) => handleUpdate({ tiempoDisponible: e.target.value })}
                            />
                        </div>
                        {/* Límites */}
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Reservas anuales:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.anuales}
                                onChange={(e) => handleUpdate({ anuales: e.target.value })}
                            />
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Reservas mensuales:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.mensuales}
                                onChange={(e) => handleUpdate({ mensuales: e.target.value })}
                            />
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Reservas diarias:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.diarias}
                                onChange={(e) => handleUpdate({ diarias: e.target.value })}
                            />
                        </div>
                        <div className="tw-flex tw-flex-col">
                            <label className="tw-font-semibold tw-mb-0.5 tw-text-xs">Reservas abiertas:</label>
                            <input
                                type="number"
                                min="0"
                                onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                className="input-edit-select-sm tw-text-left"
                                value={state.consecutivas}
                                onChange={(e) => handleUpdate({ consecutivas: e.target.value })}
                            />
                        </div>
                    </div>
                </div>

                {/* Bloque aforo máximo */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm tw-space-y-1.5">
                    <h3 className="tw-font-extrabold tw-text-lg tw-underline tw-text-purple-950">Aforo máximo</h3>

                    <div className="tw-flex tw-items-center tw-gap-2">
                        <input
                            type="checkbox"
                            id="aforoMax"
                            checked={state.aforoMax}
                            onChange={(e) => handleUpdate({ aforoMax: e.target.checked })}
                            className="tw-peer tw-h-4 tw-w-4 tw-accent-purple-600 tw-shrink-0"
                        />
                        <label
                            htmlFor="aforoMax"
                            className="tw-ml-1.5 tw-font-semibold tw-text-xs tw-whitespace-nowrap peer-checked:tw-text-purple-600"
                        >
                            Aforo máximo
                        </label>
                    </div>

                    {state.aforoMax && (
                        <div className="tw-grid tw-grid-cols-2 tw-gap-1.5 tw-mt-1.5">
                            <div className="tw-flex tw-flex-col">
                                <label htmlFor="aforo" className="tw-font-semibold tw-mb-0.5 tw-text-xs tw-whitespace-nowrap">Aforo máximo:</label>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-mb-0.5 tw-leading-tight">
                                    Cantidad máxima de personas que pueden estar en un mismo horario
                                </p>
                                <input
                                    id="aforo"
                                    type="number"
                                    min="1"
                                    onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                    className="input-edit-select-sm tw-text-left"
                                    value={state.aforo}
                                    onChange={(e) => handleUpdate({ aforo: parseInt(e.target.value) })}
                                />
                            </div>

                            <div className="tw-flex tw-flex-col">
                                <label htmlFor="maXVivienda" className="tw-font-semibold tw-mb-0.5 tw-text-xs tw-whitespace-nowrap">Máximo por vivienda:</label>
                                <p className="tw-text-[10px] tw-text-gray-500 tw-mb-0.5 tw-leading-tight">
                                    Cantidad máxima de personas que una vivienda puede reservar en un mismo horario
                                </p>
                                <input
                                    id="maXVivienda"
                                    type="number"
                                    min="1"
                                    onKeyDown={(e) => ["-", "e", "E", "+"].includes(e.key) && e.preventDefault()}
                                    className="input-edit-select-sm tw-text-left"
                                    value={state.maXVivienda}
                                    onChange={(e) => handleUpdate({ maXVivienda: parseInt(e.target.value) })}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* Bloque gestión */}
                <div className="tw-border tw-rounded-md tw-p-1.5 tw-shadow-sm tw-space-y-1.5">
                    <h3 className="tw-font-extrabold tw-text-lg tw-underline tw-text-purple-950">Gestión del área común</h3>

                    <div className="tw-grid tw-grid-cols-2 tw-gap-1.5">
                        <div className="tw-flex tw-flex-col tw-gap-1">
                            <div className="tw-flex tw-items-center">
                                <input
                                    id="pausar"
                                    type="checkbox"
                                    checked={state.pausar}
                                    onChange={(e) => handleUpdate({ pausar: e.target.checked })}
                                    className="tw-peer tw-h-4 tw-w-4 tw-accent-blue-600 tw-shrink-0"
                                />
                                <label htmlFor="pausar" className="tw-ml-1.5 tw-font-semibold tw-text-xs tw-whitespace-nowrap peer-checked:tw-text-blue-600">
                                    Pausar reservas
                                </label>
                            </div>
                            {state.pausar && (
                                <textarea
                                    name="motivo"
                                    rows="2"
                                    className="tw-w-full input-edit-sm tw-text-left"
                                    value={state.motivo}
                                    onChange={(e) => handleUpdate({ motivo: e.target.value })}
                                />
                            )}
                        </div>

                        <div className="tw-flex tw-items-center">
                            <input
                                id="activo"
                                type="checkbox"
                                checked={state.activo}
                                onChange={(e) => handleUpdate({ activo: e.target.checked })}
                                className="tw-peer tw-h-4 tw-w-4 tw-accent-green-600 tw-shrink-0"
                            />
                            <label htmlFor="activo" className="tw-ml-1.5 tw-font-semibold tw-text-xs tw-whitespace-nowrap peer-checked:tw-text-green-600">
                                Activar área común
                            </label>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    );
}